import { useMutation } from '@tanstack/react-query';
import createPrivateAdminPanelInstance from '../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../api/ApiRoutes';

const postDeleteWithdrawalRule = async ({ rule_id }) => {
  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.DELETE_WITHDRAWAL_RULE,
    { rule_id }
  );
  return response.data;
};

export const useDeleteWithdrawalRule = () => {
  return useMutation({
    mutationFn: postDeleteWithdrawalRule,
  });
};
